import { defineComponent as _defineComponent } from 'vue'
import ImageUpload from '@/components/image-upload.vue'
import { LibAppType, LibLoginType } from '@/consts'
import { store } from '../store'


export default /*#__PURE__*/_defineComponent({
  __name: 'base-form',
  setup(__props) {

const edit = store.edit

const loginTypeChange = val => {
  if (val && ~val.indexOf(3)) {
    edit.data.login_type = [3]
  }
}

return { __sfc: true,edit, loginTypeChange, ImageUpload, LibAppType, LibLoginType }
}

})